export const isAdminPromotionType = (type: string): type is 'national' | 'fallback' =>
  type === 'national' || type === 'fallback'
